import { Mutations } from 'vuex-smart-module';

import { RefState } from './state';

export class RefMutations extends Mutations<RefState> {}
